import Lottie from "lottie-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import classroomViewIcon from "../../../../../assets/jsons/classroom_view.json";
import inclassSessionIcon from "../../../../../assets/jsons/Inclass_session.json";
import studentViewIcon from "../../../../../assets/jsons/student_view.json";
import groupViewIcon from "../../../../../assets/jsons/group_view.json";
import learningPlanIcon from "../../../../../assets/jsons/learning_plan.json";
import resourcesIcon from "../../../../../assets/jsons/resources.json";
import storiesIcon from "../../../../../assets/jsons/stories.json";
import activitiesIcon from "../../../../../assets/jsons/activities.json";
import exploreAppIcon from "../../../../../assets/jsons/explore_app.json";
import sidebarToggleIcon from "../../../../../assets/Icons/sidebar.png";
import appHeaderLogo from "../../../../../assets/Icons/appHeaderLogo.png";
import ConfirmModal from "../../../../../components/ConfirmModal/ConfirmModal";
import "./AdminSidebar.scss";

const SECTIONS = [
  {
    label: "INSIGHTS",
    items: [
      {
        id: "TEACHER_VIEW",
        label: "In-class session",
        icon: inclassSessionIcon,
      },
      {
        id: "CLASSROOM_VIEW",
        label: "Classroom View",
        icon: classroomViewIcon,
      },
      { id: "STUDENT_VIEW", label: "Student View", icon: studentViewIcon },
    ],
  },
  {
    label: "WORKSPACE",
    items: [
      { id: "GROUP_VIEW", label: "All Groups", icon: groupViewIcon },
      { id: "LEARNING_PLAN", label: "Learning Plan", icon: learningPlanIcon },
      { id: "RESOURCES", label: "Resources", icon: resourcesIcon },
    ],
  },
  {
    label: "CLASSROOM",
    items: [
      { id: "TROO_STORIES", label: "Troo stories", icon: storiesIcon },
      { id: "ACTIVITIES", label: "Activities", icon: activitiesIcon },
      { id: "EXPLORE_APP", label: "Explore app", icon: exploreAppIcon },
    ],
  },
];

type Props = {
  activeTab: string;
  onChange: (tab: string) => void;
  isCollapsed: boolean;
  onToggle: () => void;
};

const AdminSidebar = ({
  activeTab,
  onChange,
  isCollapsed,
  onToggle,
}: Props) => {
  const navigate = useNavigate();
  const [showExploreConfirm, setShowExploreConfirm] = useState(false);

  return (
    <aside className={`admin-sidebar${isCollapsed ? " collapsed" : ""}`}>
      <div className="sidebar-header">
        {!isCollapsed && (
          <img src={appHeaderLogo} alt="logo" className="sidebar-logo" />
        )}
        <button
          className="sidebar-toggle"
          onClick={onToggle}
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          title={isCollapsed ? "Expand" : "Collapse"}
        >
          <img src={sidebarToggleIcon} alt="toggle" width={48} height={48} />
        </button>
      </div>

      <nav className="sidebar-nav">
        {SECTIONS.map((section, sIdx) => (
          <div className="sidebar-section" key={section.label}>
            {sIdx > 0 && <div className="sidebar-divider" />}

            <span className="sidebar-section-label">{section.label}</span>

            {section.items.map(({ id, label, icon }) => (
              <button
                key={id}
                className={`sidebar-nav-item${activeTab === id ? " active" : ""}`}
                onClick={() => {
                  if (id === "EXPLORE_APP") {
                    setShowExploreConfirm(true);
                  } else {
                    onChange(id);
                    navigate(
                      `/dashboard/${id.toLowerCase().replace(/_/g, "-")}`,
                    );
                  }
                }}
                title={isCollapsed ? label : undefined}
              >
                <span className="sidebar-icon">
                  <Lottie
                    animationData={icon}
                    loop
                    autoplay
                    style={{ width: 32, height: 32 }}
                  />
                </span>
                {!isCollapsed && <span className="sidebar-label">{label}</span>}
              </button>
            ))}
          </div>
        ))}
      </nav>

      <ConfirmModal
        isOpen={showExploreConfirm}
        title="Are you sure you want to switch to WebApp?"
        message=""
        confirmText="Yes"
        cancelText="No"
        onConfirm={() => {
          setShowExploreConfirm(false);
          localStorage.setItem("selectedMode", "webapp");
          window.location.href = "/web/rooms";
        }}
        onCancel={() => setShowExploreConfirm(false)}
      />
    </aside>
  );
};

export default AdminSidebar;
